import {getAxios, getEndpointBase} from "./base.api";
import * as querystring from "../utils/querystring";
import { getLanguageCode } from "../../selectors/generic";
import { GetPackaging } from "../../interfaces/ecom/schema";

const ENDPOINT = "GetPackaging";
const MULTIPLE_ENDPOINT = "GetPackagings";

const axios = getAxios();

interface IRequestData {
    AEMProductID: string;
    isObsolete?: boolean;
}

interface IRequestDataMultiple {
    AEMProductIDs: Array<string>;
}

export async function getProductPackaging({AEMProductID, isObsolete = false}: IRequestData): Promise<GetPackaging> {
    const countryLanguage = getLanguageCode();
    const apiUrl = getEndpointBase(ENDPOINT);

    const queryString = querystring.stringify({
        AEMProductID,
        Language: countryLanguage,
    });

    try {
        const response = await axios.get(`${apiUrl}?${queryString}`);
        if (response.status >= 200 && response.status < 300) {
            return response.data;
        } else if (isObsolete) {
            //sometimes the product is obsolete and the API returns a 400, we handle it gracefully so client still can render the page
            return response.data;
        } else {
            throw new Error(`Error: status ${response.status} Data: ${response.data}`);
        }
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export async function getProductsPackaging({AEMProductIDs}: IRequestDataMultiple): Promise<GetPackaging> {
    const countryLanguage = getLanguageCode();
    const apiUrl = getEndpointBase(MULTIPLE_ENDPOINT);

    const queryString = querystring.stringify({
        Language: countryLanguage,
    });

    const body = {"AEMProductIds": AEMProductIDs};

    try {
        const response = await axios.post(`${apiUrl}?${queryString}`, body);
        if (response.status >= 200 && response.status < 300) {
            return response.data;
        } else {
            throw new Error(`Error: status ${response.status} Data: ${response.data}`);
        }
    } catch (error) {
        console.error(error);
        throw error;
    }
}
